/**
 * Format a salary number using Dutch notation.
 * - Decimals use comma: 16.20 → "16,20"
 * - Thousands use dot: 2600 → "2.600"
 * - Whole numbers don't show decimals: 2600.00 → "2.600"
 */
export function formatSalaryDutch(value: number): string {
  // Check if value has meaningful decimals
  const hasDecimals = value % 1 !== 0;
  
  return value.toLocaleString('nl-NL', {
    minimumFractionDigits: hasDecimals ? 2 : 0,
    maximumFractionDigits: 2,
  });
}
